import { ImpersonateAsUser } from "./ImpersonateAsUser";
import type { FC } from "react";

import { DropdownMenuContent } from "@certa/catalyst/components/Dropdown";

import { DROPDOWN_MENU_WIDTH } from "./constants";
import { InstanceSettings } from "./InstanceSettings";
import { MySubscriptions } from "./MySubscriptions";
import { SupportLinks } from "./SupportLinks";
import { UserProfile } from "./UserProfile";
import { Logout } from "./Logout";
import { ActivityLogs } from "./ActivityLogs";
import { RecordsDropdownItem } from "./Records";
import { useIsAuditLogsEnabled } from "../../../../../hooks/useCanViewStudio2";

export const OverlayMenu: FC = () => {
  const isAuditLogsEnabled = useIsAuditLogsEnabled();
  return (
    <DropdownMenuContent align="end" width={DROPDOWN_MENU_WIDTH}>
      <MySubscriptions />
      <RecordsDropdownItem />
      <SupportLinks />
      <ImpersonateAsUser />
      <InstanceSettings />
      {isAuditLogsEnabled && <ActivityLogs />}
      <UserProfile />
      <Logout />
    </DropdownMenuContent>
  );
};
